<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-13 01:06:41
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:28:49
 * @Description: file content
 底部的小程序码，应该一直是自己的。因为这个算自己的传播。不是名片人的名片。
 -->

<template>
  <div class="warp" v-if="cardInfo">
    <div class="usercard" v-if="isShowMyCard">
      <div class="top">
        <div class="head">
          <img :src="cardInfo.Ui.HeadImg" alt />
        </div>
        <div class="fields">
          <div class="field">
            <span v-if="isInMiniProgram" class="value company">
              <span>{{cardInfo.Ui.Name}}</span>
              <span>{{' '+cardInfo.User.Company}}</span>
            </span>
            <span v-else class="value company company-web">
              <span>{{cardInfo.Ui.Name}}</span>
              <span>{{' '+cardInfo.User.Company}}</span>
            </span>
          </div>
          <div class="field">
            <span class="label">电话</span>
            <span class="value">
              <a :href="'tel:'+cardInfo.User.Phone">{{cardInfo.User.Phone}}</a>
            </span>
          </div>
          <div class="field">
            <span class="label">微信</span>
            <span class="value">{{cardInfo.User.Wechat}}</span>
          </div>
        </div>
      </div>
      <div class="bottom">很多客—领先的AI获客神器，{{count}}人正在使用，包括{{count2}}位您的好友，很多客内置多种裂变获客工具，还有AI助理帮你找客户</div>
      <div v-if="isInMiniProgram" class="btn" @click="clickChangeMy">立即使用</div>
      <img
        v-if="!isInMiniProgram&&cardInfo&&cardInfo.mpQrCode"
        class="qrcodeimg"
        :src="cardInfo.mpQrCode"
        alt
      />
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import wx from "weixin-js-sdk";
export default {
  components: {},
  props: {},
  data() {
    return {
      count: 0,
      count2: 0
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "isShowMyCard"
    ])
  },
  methods: {
    clickChangeMy() {
      // 点击这个按钮的时候说明是在小程序内部，所以跳转不需要参数
      wx.miniProgram.switchTab({
        url: `/pages/hdk/intro/intro`
      });
    }
  },
  created() {
    this.count = util.randomNum(1000000, 2000000);
    this.count2 = util.randomNum(10, 100);
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.warp {
  background-color: #f5f5f5;
  padding: 0.3rem 0;
}
a {
  color: #333333;
}
.usercard {
  /* background-image: url("https://assets.rurushishi.com/yq-rs-make/components/usercard/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat; */
  height: auto;
  color: #333333;
  font-size: 12px;
  margin: 0 0.3rem;
  box-shadow: 0 0 5px #cbcbcb;
  position: relative;
  background-color: #ffffff;
  border-radius: 5px;
}
.usercard .top {
  display: flex;
}

.usercard .top .head {
  min-width: 2rem;
  text-align: center;
  padding-top: 0.4rem;
}
.usercard .top .head img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.6rem;
}
.usercard .top .fields {
  padding-top: 0.2rem;
}
.usercard .top .fields > .field {
  line-height: 0.5rem;
  display: flex;
}
.usercard .top .fields > .field > span {
  display: block;
}
.usercard .top .fields > .field .label {
  padding-right: 0.1rem;
  white-space: nowrap;
  color: #8b8b8b;
}
.usercard .top .fields > .field .value {
  padding-right: 0.2rem;
}
.usercard .top .fields > .field > .company span:first-child {
  color: #333333;
  font-weight: 600;
}
.usercard .top .fields > .field > .company span:nth-child(2) {
  color: #333333;
}
.usercard .top .fields > .field > .company-web {
  overflow: hidden;
  display: inline-block;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 90%;
}
.usercard .bottom {
  text-align: left;
  font-size: 10px;
  line-height: 20px;
  margin: 0 0.3rem;
  color: #999999;
  margin-top: 0.2rem;
  border-top: 1px solid #b9b9b9;
  padding-top: 0.2rem;
  padding-bottom: 0.3rem;
  text-align: justify;
}

.usercard .btn {
  position: absolute;
  top: 40px;
  right: 20px;
  width: 1.5rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.35rem;
  color: #f46263;
  border: 1px solid #f46263;
  text-align: center;
  font-size: 14px;
}
.usercard .qrcodeimg {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 5px;
  right: 20px;
}
</style>